import Form from './Form';
import {errorHandler, getSkey, request} from './HttpClient';
import {addEventListenerIfExist, addLiveEventListener, scrollToTarget} from './utils';

// TODO: refactor jQuery --> ES
export default class Wishlist {
	constructor(app) {
		this.app = app;
		const self = this;

		const form = document.querySelector('#merkzettel_form');
		if (form !== null) {
			Form.addressAutocomplete({
				form: form,
				options: {
					bounds: Form.EUROPE_BOUNDS,
					strictBounds: true,
				}
			});
		}

		this.wishlistHeaderBadge = document.querySelector('.js-wishlist');
		this.form = document.querySelector('#merkzettel_form');
		this.popupProgress = document.querySelector('#form_progress');
		this.popupSuccess = document.querySelector('#form_success');
		this.popupSuccessSend = document.querySelector('#form_success_send');
		this.saveButton = document.querySelector('#mk_save');
		this.sendButton = document.querySelector('#mk_send');

		this.loadMerkzettel();
		$(document).on("click", "#addmerkzettel", (e) => {
			e.preventDefault();
			if (!self.writeToSession($(e.currentTarget), false)) { // if no error activate Merkzettel
				self.showMerkzettelLink();
			}
		});

		$(document).on("click", ".js-eBox-favorite", (e) => {
			$(e.currentTarget).closest(".js-vBox-wrap").toggleClass("is-active");
		});

		$(document).on("click", "#addandshowmerkzettel", (e) => { // addItem to Merkzettel
			e.preventDefault();
			self.writeToSession($(e.currentTarget), true);
		});

		$(".js_mk_del_btn").on("click", function () { // delete item from Merkzettel
			let btn = $(this);
			$.ajax({
				type: "POST",
				url: "/merkzettel/deleteItem",
				data: {"ukey": btn.data("ukey")},
				success: function (data) {
					if (btn.data("ukey") === 'all') {
						window.location.href = self.form.dataset.successUrl;
					} else {
						window.location.href = '/merkzettel';
					}
				}
			});
		});

		[this.saveButton, this.sendButton].forEach(btn => {
			if (!btn) return;
			btn.addEventListener('click', event => {
				event.preventDefault();
				if (self.validate()) {
					self.saveMerkzettel(btn === this.sendButton);
					if ('ga' in window) { // is analytics enabled?
						ga('send', 'event', 'Bookmark', btn.value, btn.value);
					}
				}
			})
		});

		// for button in buy-box on variant[e] view
		addLiveEventListener('click', '.js-wishlist-add', function (e) {
			e.preventDefault();
			e.stopPropagation();

			if(document.documentElement.classList.contains('is-cusi')) {
				console.debug('Handle variant cusi!');
				return window.top.wishlistAddCallback(e);
			}

			request('/merkzettel/addItemByKey', {
				method: 'POST',
				params: {key: this.dataset.key},
			})
				.then(req => req.json())
				.then(response => {
					self.updateBadge(response);
					window.location.href = '/merkzettel';
				})
				.catch(errorHandler)
		});

		addEventListenerIfExist('click', e => {
			e.preventDefault();
			e.stopPropagation();
			window.location.href = this.form.dataset.successUrl;
		}, this.popupSuccessSend);
	}

	validate() {
		let wishlistFormHasError = false;

		if (!this.form) {
			console.error('Form does not exists');
			return false;
		}
		this.form.classList.add('form-group--validation')

		// valiate gdpr (DSGVO) checkbox
		const gdprOkayCheckbox = this.form.querySelector('#gdpr_okay');
		const gdprOkayLabel = gdprOkayCheckbox.labels[0];
		if (!gdprOkayCheckbox.checked) {
			wishlistFormHasError = true;
			gdprOkayLabel.parentElement.classList.add('is-invalid');
			gdprOkayCheckbox.classList.add('is-invalid');
		} else {
			gdprOkayLabel.parentElement.classList.remove('is-invalid');
			gdprOkayCheckbox.classList.remove('is-invalid');
		}

		// valiate required fields
		this.form.querySelectorAll('input.is-required').forEach(input => {
			if (input.value === '') {
				wishlistFormHasError = true;
				this.form.querySelector('#contactform').classList.add('is-invalid');
				input.classList.add('is-invalid');
			} else {
				this.form.querySelector('#contactform').classList.remove('is-invalid');
				input.classList.remove('is-invalid');
			}
		});

		// valiate email
		const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		const emailInput = this.form.querySelector('input#ignt-id-email');
		if (!regex.test(emailInput.value)) {
			wishlistFormHasError = true;
			this.form.querySelector('#contactform').classList.add('is-invalid');
			emailInput.classList.add('is-invalid');
		} else {
			this.form.querySelector('#contactform').classList.remove('is-invalid');
			emailInput.classList.remove('is-invalid');
		}

		// scrollt to first invalid field
		if (wishlistFormHasError) {
			scrollToTarget(this.form.querySelector('input.is-invalid') || this.form, -100);
			return false;
		}
		return true;
	}


	writeToSession($obj, feedback) {
		let self = this;
		let $form = $obj.closest("form"); // get closest Form

		let error = false;
		let $firstErrorBone;

		$form.addClass("form-group--validation");

		$form.find(".requiredbone").each(function (i, val) { // check requiredBones and mark and unmark valid and invalid states
			if ($(this).val() == "" || $(this).val() == "-" || $(this).val() == "-1" || $(this).val() == null) {
				$(this).addClass("is-invalid").removeClass("is-valid");

				error = true;
				if (!$firstErrorBone) {
					$firstErrorBone = $(this);
				}
			} else {
				$(this).removeClass("is-invalid").addClass("is-valid");
			}
		});

		if (error) { // if an error found scroll to it
			scrollToTarget($firstErrorBone.get(), -200);
		} else { //send to merkzettel
			request('/merkzettel/addItem', {
				method: 'POST',
				params: $form.get(0),
			})
				.then(req => req.json())
				.then(response => {
					self.updateBadge(response);
					// if called with feedback navigate to Merkzettel
					if (feedback) {
						window.location.href = '/merkzettel';
					}
				})
				.catch(errorHandler)
		}
		return error
	}

	loadMerkzettel() {
		const self = this;
		if (self.wishlistHeaderBadge === null) return;
		request('/merkzettel/load')
			.then(req => req.json())
			.then(self.updateBadge.bind(self));
	}

	/**
	 * Update the wishlist badge in the header from a response.
	 * @param {object} response The response, holding the items and the key, if set.
	 */
	updateBadge(response) {
		const self = this;
		const amount = response['items'] ? Object.keys(response['items']).length : 0;
		if (amount > 0) {
			let translation = self.wishlistHeaderBadge.dataset.translationArticle;
			self.wishlistHeaderBadge.title = `${amount} ${translation}`;
			self.wishlistHeaderBadge.setAttribute('data-count', amount.toString());
		} else {
			self.wishlistHeaderBadge.removeAttribute('data-count');
		}
	}

	showMerkzettelLink() {
		$('html, body').animate({
			scrollTop: 0
		}, 300, () => {
			setTimeout(() => {
				$('.js-subnav-into-favs-tip').addClass("tip");

			}, 100);

			setTimeout(() => {
				$('.js-subnav-into-favs-tip').removeClass("tip");
			}, 5000);
		});
		try {
			$('.js-wishlistfeedback').addClass("is-active");
		} catch (e) {
		}
	}

	/**
	 * Save the wishlist.
	 * @param {boolean} send true for save & send, false for save only
	 */
	saveMerkzettel(send = false) {
		let self = this;

		self.disableButtons();
		self.popupProgress.classList.add('is-active');
		self.popupSuccess.classList.remove('is-active');
		self.popupSuccessSend.classList.remove('is-active');

		Promise.all([
			request('/merkzettel/load').then(req => req.json()),
			getSkey(),
		])
			.then(([response, skey]) => {
				self.form.querySelector('input[name="skey"]').value = skey;
				self.form.querySelector('input[name="issaved"]').value = send ? 'True' : 'False';

				let url
				if (typeof response['key'] != 'undefined') { // allready saved > EDIT
					url = `/json/merkzettel/edit/${response["key"]}`;
				} else { // new Merkzettel > ADD
					url = `/json/merkzettel/add`;
				}

				request(url, {
					method: 'POST',
					params: self.form
				})
					.then(req => req.json())
					.then(response => {
						self.popupProgress.classList.remove('is-active');
						if (send) {
							self.popupSuccessSend.classList.add('is-active');
							window.dataLayer.push({
								event: 'form_success_send',
							});
						} else {
							self.popupSuccess.classList.add('is-active');
							self.enableButtons();
						}
						self.updateBadge(response);
					})
					.catch(error => {
						self.enableButtons();
						errorHandler(error);
					});
			});
	}

	disableButtons(invert = false) {
		[this.saveButton, this.sendButton].forEach(btn => btn.disabled = !invert);
	}

	enableButtons() {
		return this.disableButtons(true);
	}
}

